const DASHBOARD_GREETINGS = {
  morning: [
    { text: 'Good Morning', emoji: '☀️' },
    { text: 'Big wins today', emoji: '🌤️' },
    { text: 'Rise and shine', emoji: '🌅' },
    { text: 'Here’s to a strong start', emoji: '🚀' },
  ],
  afternoon: [
    { text: 'Good Afternoon', emoji: '☀️' },
    { text: 'You’re onto something', emoji: '💡' },
    { text: 'Hope your day is going well', emoji: '✨' },
    { text: 'Keep the momentum going', emoji: '⚡' },
  ],
  evening: [
    { text: 'Good Evening', emoji: '🌆' },
    { text: 'One step closer', emoji: '🎯' },
    { text: 'Here’s to a strong finish', emoji: '✨' },
    { text: 'Hope you had a productive day', emoji: '🙌' },
  ],
  lateNight: [
    { text: 'Good Evening', emoji: '🌙' },
    { text: 'Burning the midnight oil', emoji: '🌙' },
    { text: 'Still building', emoji: '🛠️' },
    { text: 'One more thing before you call it', emoji: '✨' },
  ],
};

const INCUBATOR_DASHBOARD_GREETINGS = {
  morning: [
    { text: 'Good morning', emoji: '☀️' },
    { text: 'Let’s check in on your founders', emoji: '🌱' },
    { text: 'A new day for bold ideas', emoji: '💡' },
    { text: 'Let’s give founders a strong start', emoji: '🌅' },
  ],
  afternoon: [
    { text: 'Good afternoon', emoji: '☀️' },
    { text: 'Let’s keep your founders moving', emoji: '🚀' },
    { text: 'Time for a founder check-in', emoji: '🤝' },
    { text: 'Good ideas deserve good support', emoji: '💡' },
  ],
  evening: [
    { text: 'Good evening', emoji: '🌆' },
    { text: 'Let’s look at the day’s progress', emoji: '📈' },
    { text: 'A moment to see the bigger picture', emoji: '🔭' },
    { text: 'Let’s wrap up with your founders', emoji: '✨' },
  ],
  lateNight: [
    { text: 'Good to see you', emoji: '🌙' },
    { text: 'A quiet moment for the big picture', emoji: '🌌' },
    { text: 'Here’s to tomorrow’s big ideas', emoji: '💡' },
    { text: 'Let’s take a thoughtful pause', emoji: '✨' },
  ],
};

const getGreetingPeriod = (hour) => {
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 23) return 'evening';
  return 'lateNight';
};

export const getDashboardGreeting = (date = new Date()) => {
  const period = getGreetingPeriod(date.getHours());
  const options = DASHBOARD_GREETINGS[period];
  return options[Math.floor(Math.random() * options.length)];
};

export const getIncubatorDashboardGreeting = (date = new Date()) => {
  const options = INCUBATOR_DASHBOARD_GREETINGS[getGreetingPeriod(date.getHours())];
  return options[Math.floor(Math.random() * options.length)];
};

export { DASHBOARD_GREETINGS, INCUBATOR_DASHBOARD_GREETINGS };
